import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import "../css/ImportRatioChart.css";

const ImportRatioChart = ({ data, COLORS, isShowLegend, isCustomLegend }) => {
  data= data?.filter((e)=>e.name!='Total');
  return (
    <div className="chart-container">
      <PieChart width={250} height={250}>
        <Pie
          data={data}
          cx={130}
          cy={100}
          labelLine={false}
          // label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
          outerRadius={100}
          fill="#8884d8"
          // dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cel-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        {isShowLegend == true ? <Legend /> : ""}
      </PieChart>
      {isCustomLegend == true ? (
        <div className="custom-legend">
          {data.map((entry, index) => (
            <div key={`legend-${index}`} className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></span>
              {data.length > 1 ? (
                <span className="legend-text">
                  {`${entry.name}: ${entry.value} SQM`}
                </span>
              ) : (
                <span className="legend-text">{`${entry.name}: ${(
                  (entry.value / data.reduce((a, b) => a + b.value, 0)) *
                  100
                ).toFixed(0.0)}%`}</span>
              )}
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ImportRatioChart;
